import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import splitHtmlString from '../utilities/splitHtmlString.js';

gsap.registerPlugin(ScrollTrigger);

const setup = () => {
  let mediaManager = gsap.matchMedia();

  const blocks = document.querySelectorAll(
    '.w-b-text-media, .w-b-variation-selector, [data-w-comparison]'
  );

  mediaManager.add(
    {
      isMobile: `(max-width: 768px), (min-width: 768px) and (max-width: 1366px) and (orientation: portrait)`,
      isDesktop: `(min-width: 768px) and (max-width: 1366px) and (orientation: landscape), (min-width: 1366px)`,
    },
    (context) => {
      let { isDesktop, isMobile } = context.conditions;

      if (isDesktop) {
        blocks.forEach((trigger) => {
          gsap.set(trigger, { '--_progress': 1 });
          // if (!trigger.classList.contains('w-b-single-media')) {
          //   gsap.to(trigger, {
          //     scrollTrigger: {
          //       trigger: trigger,
          //       start: 'bottom bottom',
          //       end: 'bottom top',
          //       scrub: true,
          //       fastScrollEnd: true,
          //       onUpdate: (self) => {
          //         const progress = gsap.parseEase('power3.inOut')(
          //           self.progress
          //         );
          //         trigger.style.setProperty('--_progress', progress);
          //       },
          //     },
          //   });
          // } else {
          gsap.to(trigger, {
            scrollTrigger: {
              trigger: trigger,
              start: 'top 90%',
              end: 'top 50%',
              scrub: true,
              fastScrollEnd: true,
              onUpdate: (self) => {
                const progress = gsap.parseEase('power3.inOut')(self.progress);
                trigger.style.setProperty('--_progress', 1 - progress);
              },
            },
          });
          // }

          if (trigger.classList.contains('w-b-text-media')) {
            gsap.to(trigger, {
              scrollTrigger: {
                trigger: trigger,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
                fastScrollEnd: true,
                onUpdate: (self) => {
                  trigger.style.setProperty('--_offset', -0.5 + self.progress);
                },
              },
            });
          }
        });
      }

      const footer = document.querySelector('footer');
      const footerInner = footer.querySelector('[data-footer-trigger]');
      gsap.to(footer, {
        scrollTrigger: {
          trigger: footer,
          start: 'top 80%',
          end: 'top 50%',
          scrub: true,
          onUpdate: (self) => {
            footer.style.setProperty('--_progress', self.progress);
          },
        },
      });
      gsap.fromTo(
        footerInner,
        {
          opacity: 0,
          yPercent: -20,
        },
        {
          opacity: 1,
          yPercent: 0,
          duration: 0.8,
          scrollTrigger: {
            trigger: footer,
            start: 'top 80%',
            end: 'top 20%',
            scrub: true,
          },
        }
      );
    }
  );
};

export default function InView() {
  return {
    init: () => {
      setup();
    },
  };
}
